import { z } from "zod";

import { ERROR_TYPE } from "@/utils";
import { TokenPurpose } from "@/enum";

const { REQUIRED } = ERROR_TYPE;

export const ConfirmPasswordSchema = z.object({
	token: z.string().min(1, { message: REQUIRED }),
	purpose: z.nativeEnum(TokenPurpose),
});

export type ConfirmEmailType = z.infer<typeof ConfirmPasswordSchema>;
